import { salary } from '../../i18n/translatedMessages'

export function Header() {
	return (
		<div className='tw-mb-6'>
			<h4 className='tw-font-bold'>{salary.title}</h4>
			<p>{salary.subtitle}</p>
		</div>
	)
}
